import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MovablePanelTitleComponent } from '../movable-panel-title';

@Component({
  selector: 'app-moveable-panel',
  imports: [MovablePanelTitleComponent],
  templateUrl: './moveable-panel.component.html',
  host: {
    class: 'flex flex-col bg-background-moveable rounded-radius-primary',
    '[class.filter-custom-card-moveable]': '!withoutShadow()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoveablePanelComponent {
  public title = input<string>();
  public withoutShadow = input<boolean>(false);
}
